import { createFileRoute } from "@tanstack/react-router";
import FeedImportPage from "@/pages/dashboard/FeedImport";
import SubscribedRoute from "@/components/shared/SubscribedRoute";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/dashboard/feed-import/")({
  head: () => routeHead("/dashboard/feed-import/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <SubscribedRoute><FeedImportPage /></SubscribedRoute>
  );
}
